/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_DELIVERED, GET_PRESENTATIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
const storageSrv = StorageModule.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IUserListsMethods extends IPluginMethodMap {
  getUserListsProps(args: any): Promise<any>;
}

export class UserListsService implements IAgentPlugin {
  readonly methods: IUserListsMethods;

  constructor() {
    this.methods = {
      getUserListsProps: this.getUserListsProps.bind(this),
    };
  }

  async getUserListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("args 41==>", pretty(args));
    try {
      if (client) {
        const presentationsFilter = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            // filter: {
            //   status: {
            //     eq: "active",
            //   },
            // },
          },
          fetchPolicy: "network-only",
        });

        const activeItem =
          presentationsFilter?.data?.getPresentations?.content.find(
            (item: any) => item.status === "active"
          );
        console.log("activeItem==>", activeItem);
        const defaultPresentation =
          activeItem && activeItem?.id
            ? activeItem?.id
            : presentationsFilter?.data?.getPresentations?.content[0]?.id;
        const band =
          storageSrv.get("currencyExchangeLocal", "local")?.bandId ?? null;
        let filter: any = {
            band: {
              eq: band,
            },
          },
          options = {};
        if (args?.offset !== undefined && args?.size !== undefined) {
          options = { skip: args?.offset, limit: args?.size };
        }
        filter =
          args?.criteria?.email === "" || args?.criteria?.email === undefined
            ? {
                ...filter
              }
            : {
                ...filter,
                CreatedByUser___email: {
                  eq: args?.criteria?.email,
                },
              };
        if (args?.criteria?.currDate && args?.criteria?.endDate) {
          filter = {
            ...filter,
            TokenDeliveredTime: {
              gte: args?.criteria?.currDate,
              lt: args?.criteria?.endDate,
            },
          };
        } else if (args?.criteria?.currDate && !args?.criteria?.endDate) {
          filter = {
            ...filter,
            TokenDeliveredTime: {
              gte: args?.criteria?.currDate,
            },
          };
        } else if (!args?.criteria?.currDate && args?.criteria?.endDate) {
          filter = {
            ...filter,
            TokenDeliveredTime: {
              lt: args?.criteria?.endDate,
            },
          };
        }
        const res = await client.query({
          query: GET_DELIVERED,
          variables: {
            filters: filter,
            options: options,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatUserTable(
            res?.data?.getDeliverStatus?.content
          );
          let _currentPage =
            res?.data?.getDeliverStatus?.skip /
              res?.data?.getDeliverStatus?.limit +
            1;
          let _totalPages = res?.data?.getDeliverStatus?.count
            ? Math.ceil(parseInt(res?.data?.getDeliverStatus?.count) / 10)
            : 1;

          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getDeliverStatus?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getDeliverStatus?.count,
            totalPages: _totalPages,
            defaultPresentation:
              args?.criteria?.presentation ?? defaultPresentation,
            PresentationFilter:
              presentationsFilter?.data?.getPresentations?.content?.map(
                (_item: any) => {
                  return { value: _item?.id, label: _item?.name };
                }
              ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LL");
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any[] = [];
    data.forEach((item: any) => {
      console.log("item", item);
      _rowData.push({
        id: item?.id ?? "-",
        userId: item?.MasqID,
        costumeID: item?.CostumeID,
        sectionName: item?.Section,
        sectionOptType: item?.SectionOptType,
        name: item?.Name,
        email: item?.Email,
        date: this.formatCreatedDate(item?.TokenDeliveredTime),
      });
    });
    return _rowData;
  }
}
